(function () {
    'use strict';
    var m = angular.module('app');
    m.controller('ExampleController', ["$scope", function ($scope) {
    }]);
}());